<template>
  <div class="modal-custom">
    <div class="modal-content">
      <div @click="$emit('close')" class="close">regresar</div>
      <h3 class="pt-3 text-center">
        Recuerda que si registras tu
        <strong>Monedero Mi Inseparables</strong>, duplicamos tus puntos
      </h3>
      <div v-if="!showSuccess">
        <p class="text-center">Si no cuentas con él en este momento, podrás registrarlo después.</p>

        <div class="row">
          <div class="col-md-6 offset-md-3">
            <form @submit="setMonedero($event)">
              <input
                v-model.trim="monedero"
                type="text"
                placeholder="Mi Monedero Inseparables"
                required
              />
              <div class="row">
                <div class="col-4 d-flex align-items-center">
                  <button
                    type="button"
                    @click="$emit('registro')"
                    class="w-100 pointer d-flex align-items-center justify-content-center btn"
                  >Omitir</button>
                </div>
                <div class="col-8">
                  <button
                    type="submit"
                    class="w-100 pointer d-flex align-items-center justify-content-center zoom btnaction"
                  >
                    <img
                      class="img-fluid"
                      src="../assets/imgs/home/continuar-btn.png"
                      alt="Continuar"
                    />
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <p v-if="errorMsg !== ''" class="error">{{ errorMsg }}</p>
      </div>
      <p v-else>¡Bien! Has registrado tu monedero.</p>
    </div>
  </div>
</template>

<script>
import { auth } from "@/firebase";

export default {
  data() {
    return {
      monedero: "",
      showSuccess: false,
      errorMsg: "",
    };
  },
  methods: {
    async setMonedero(e) {
      e.preventDefault();

      this.$emit("registro", this.monedero);
    },
  },
};
</script>
